"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _EmptyResult = _interopRequireDefault(require("./EmptyResult"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "empty-result": "DefaultTheme__empty-result___2nFjO",
  "image": "DefaultTheme__image___E8pxQ",
  "message": "DefaultTheme__message___3aWDY",
  "emptyResult": "DefaultTheme__empty-result___2nFjO"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "empty-result": "DarkTheme__empty-result___25P0x",
  "image": "DarkTheme__image___1GZtZ",
  "message": "DarkTheme__message___28I_K",
  "emptyResult": "DarkTheme__empty-result___25P0x"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "empty-result": "LumeTheme__empty-result___b14SS",
  "emptyResult": "LumeTheme__empty-result___b14SS"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_EmptyResult["default"].displayName, themes.DefaultTheme)(_EmptyResult["default"]);
ThemedComponent.displayName = _EmptyResult["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map